import { IncidentDetail } from "./incident-detail";
import { IncidentFinding } from "./incident-finding";
import { Observation } from "./observation";
import { Allergy } from "./allergy";
import { Medicine } from "./medicine";
import { MedicalHistory } from "./medical-history";
import { Person } from "./person";
import { Annotation } from "./annotation";

export class AtmistData {
    Patient: Person;
    DateCreated: Date;
    Mechanism: IncidentDetail[];
    Findings: IncidentFinding[];
    Signs: ATMISTSigns;
    Treatments: Annotation[];
    Allergies: Allergy[];
    Medications: Medicine[];
    MedicalHistory: MedicalHistory[];
    LastOralIntakes: Annotation[];
    PrecedingEvents: Annotation[];

    constructor(init?: Partial<AtmistData>) {
        Object.assign(this, init);

        if (init && init.Patient) {
            this.Patient = new Person(init.Patient);
        } else {
            this.Patient = null;
        };

        if (init && init.Mechanism) {
            this.Mechanism = init.Mechanism.map(i => new IncidentDetail(i));
        } else {
            this.Mechanism = new Array<IncidentDetail>()
        };

        if (init && init.Findings) {
            this.Findings = init.Findings.map(i => new IncidentFinding(i));
        } else {
            this.Findings = new Array<IncidentFinding>()
        };

        if (init && init.Signs) {
            this.Signs = new ATMISTSigns(init.Signs);
        } else {
            this.Signs = null;
        };

        if (init && init.Treatments) {
            this.Treatments = init.Treatments.map(a => new Annotation(a));
        } else {
            this.Treatments = new Array<Annotation>()
        };

        if (init && init.Allergies) {
            this.Allergies = init.Allergies.map(a => new Allergy(a));
        } else {
            this.Allergies = new Array<Allergy>()
        };

        if (init && init.Medications) {
            this.Medications = init.Medications.map(m => new Medicine(m));
        } else {
            this.Medications = new Array<Medicine>()
        };

        if (init && init.MedicalHistory) {
            this.MedicalHistory = init.MedicalHistory.map(m => new MedicalHistory(m));
        } else {
            this.MedicalHistory = new Array<MedicalHistory>()
        };

        if (init && init.LastOralIntakes) {
            this.LastOralIntakes = init.LastOralIntakes.map(a => new Annotation(a));
        } else {
            this.LastOralIntakes = new Array<Annotation>()
        };

        if (init && init.PrecedingEvents) {
            this.PrecedingEvents = init.PrecedingEvents.map(a => new Annotation(a));
        } else {
            this.PrecedingEvents = new Array<Annotation>()
        };
    }
}

export class ATMISTSigns {
    BloodPressue: Observation;
    BloodSugar: Observation;
    GlasgowComaScale: Observation;
    PupilDilation: Observation;
    PulseRate: Observation;
    RespiratoryRate: Observation;
    SPO2: Observation;
    Temperature: Observation;
    AVPU: Observation;

    constructor(init?: Partial<ATMISTSigns>) {
        if (init && init.BloodPressue) {
            this.BloodPressue = new Observation(init.BloodPressue);
        } else {
            this.BloodPressue = null;
        };

        if (init && init.BloodSugar) {
            this.BloodSugar = new Observation(init.BloodSugar);
        } else {
            this.BloodSugar = null;
        };

        if (init && init.GlasgowComaScale) {
            this.GlasgowComaScale = new Observation(init.GlasgowComaScale);
        } else {
            this.GlasgowComaScale = null;
        };

        if (init && init.PupilDilation) {
            this.PupilDilation = new Observation(init.PupilDilation);
        } else {
            this.PupilDilation = null;
        };

        if (init && init.PulseRate) {
            this.PulseRate = new Observation(init.PulseRate);
        } else {
            this.PulseRate = null;
        };

        if (init && init.RespiratoryRate) {
            this.RespiratoryRate = new Observation(init.RespiratoryRate);
        } else {
            this.RespiratoryRate = null;
        };

        if (init && init.SPO2) {
            this.SPO2 = new Observation(init.SPO2);
        } else {
            this.SPO2 = null;
        };

        if (init && init.Temperature) {
            this.Temperature = new Observation(init.Temperature);
        } else {
            this.Temperature = null;
        };

        if (init && init.AVPU) {
            this.AVPU = new Observation(init.AVPU);
        } else {
            this.AVPU = null;
        };
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/AtmistData.ts